import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import GridRow from 'components/GridRow';
import HealthDot from 'components/HealthDot';
import RunEditMenu from '../../RunList/RunEntry/RunEditMenu';
import { formatRunWallClock } from '../../../utils/sessionTime';

interface SimpleRunRowProps {
  run: any;
  config: any;
  session: any;
  sessions?: any[];
  invalidateRuns: () => void;
}

const buttonStyle =
  'cr-border-none cr-rounded-full cr-bg-transparent cr-text-cirrusBlue-100 hover:cr-bg-cirrusBlue-25 '
  + 'cr-shadow-none cr-transition-colors cr-duration-200 cr-cursor-pointer';

export default function SimpleRunRow({
  run,
  config,
  session,
  sessions,
  invalidateRuns,
}: SimpleRunRowProps): ReactElement {
  const navigate = useNavigate();

  return (
    <GridRow
      className="hover:cr-bg-cirrusBlue-35 cr-cursor-pointer"
      onClick={() => navigate(`/sessions/${session.id}/runs/${run.id}`)}
    >
      <div className="cr-justify-center">
        <HealthDot health={run.run_health} reasons={run.run_health_reasons} />
      </div>
      <div className="cr-justify-center">{run.run_number ?? '—'}</div>
      <div className="cr-justify-center">
        {formatRunWallClock(run.run_ts, run.timezone, 'datetime')}
      </div>
      <div className="cr-justify-start cr-truncate cr-px-2 cr-text-left">{run.description}</div>
      <div className="cr-justify-center" onClick={(e) => e.stopPropagation()}>
        <RunEditMenu
          run={run}
          config={config}
          session={session}
          sessions={sessions}
          invalidateRuns={invalidateRuns}
          buttonStyle={buttonStyle}
          moveRight
        />
      </div>
    </GridRow>
  );
}
